import { Navigate, Outlet, createFileRoute, useRouterState } from "@tanstack/react-router";

import { routeMatches } from "src/lib/vendor/tanstack/reactRouter/utils";

export const Route = createFileRoute("/updates")({
  beforeLoad() {
    return { pageName: "Updates" };
  },

  component: RouteComponent
});

export function RouteComponent() {
  const { matches } = useRouterState();

  if (routeMatches(matches, "/updates")) {
    return <Navigate to="/updates/regions" replace />;
  }

  return <Outlet />;
}
